import firebase from 'firebase/app'
import 'firebase/firestore'; // If using Firebase database
import 'firebase/storage';  // If using Firebase storage
import 'firebase/auth'; // If using Firebase database
import 'firebase/database'; // If using Realtime database
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCSqqMsEEfz6vKibbk8f8FggtQGYQ5vxv4",
    authDomain: "znoade.firebaseapp.com",
    databaseURL: "https://znoade.firebaseio.com",
    projectId: "znoade",
    storageBucket: "znoade.appspot.com",
    messagingSenderId: "476044000071",
    appId: "1:476044000071:web:fe8620dc3f116f25c72a62",
    measurementId: "G-C152M0GVSN"
};
firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
//firestore.useEmulator("10.0.0.120", 8081);
const auth = firebase.auth();
const storage = firebase.storage();
const database = firebase.database();
export {firebase, firestore, auth, storage, database};

